import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/mock/index.js'
import '@/style/common.scss'
import 'lib-flexible/flexible.js'
import { Base64 } from 'js-base64';
import '@vant/touch-emulator';
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.prototype.$Base64 = Base64;

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.name) {
    document.title = to.meta.name
  }
  next()
})



import { Image as VanImage } from 'vant';
import 'vant/lib/image/style'
Vue.use(VanImage);

import { Step, Steps } from 'vant';
import 'vant/lib/step/style'
import 'vant/lib/steps/style'
Vue.use(Step);
Vue.use(Steps);

import { Search } from 'vant';
import 'vant/lib/search/style'
Vue.use(Search);

import { Grid, GridItem } from 'vant';
import 'vant/lib/grid/style'
import 'vant/lib/grid-item/style'
Vue.use(Grid);
Vue.use(GridItem);

import { Col, Row } from 'vant';
import 'vant/lib/col/style'
import 'vant/lib/row/style'

Vue.use(Col);
Vue.use(Row);

import { Dialog } from 'vant';
import 'vant/lib/dialog/style'
Vue.use(Dialog);

import { Loading } from 'vant';
import 'vant/lib/loading/style'
Vue.use(Loading);

import { Popup } from 'vant';
import 'vant/lib/popup/style'
Vue.use(Popup);


// 引入
import Breadcrumb from "@/components/Breadcrumb";
import BreadcrumbItem from "@/components/Breadcrumb-item.vue";
// 注册为全局组件
Vue.component('Breadcrumb', Breadcrumb)
Vue.component('BreadcrumbItem', BreadcrumbItem)





Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
